export const BUDGET = 'BUDGET';
export const CHAT1 = 'CHAT1'; // 사내채팅방
export const CHAT2 = 'CHAT2'; // 고객채팅방
export const CHAT3 = 'CHAT3'; // 통합채팅방
export const COMMON = 'COMMON';
export const LEDGER = 'LEDGER';
export const ORDER = 'ORDER';
export const REPORT = 'REPORT';
export const NOTE = 'NOTE';

/**
 * 설명: 가계부 항목 추가시 (루트계정 + 현장담당자)에게 알림 전송
 * 트리거: 매출처 > 가계부 > 항목 추가
 * 수신자: 매출처 + 담당직원
 * 화면 이동: 가계부 > 상세
 * 특이사항: -
 * to: _id (현장 _id)
 * toModel: Field
 * object: {
 *   fieldId: string, // 현장 _id
 *   itemId: string, // 가계부 항목 _id
 * }
 */
export const LEDGER_ITEM_ADDED = 'LEDGER_ITEM_ADDED';
/**
 * 설명: 현장손익 내역 추가·수정·삭제·복구 시 (루트계정 + 현장담당자)에게 알림 전송
 * 트리거: 매출처 > 가계부 > field path 쓰기 API
 * 수신자: 매출처 + 담당직원 (작성자 제외)
 * 화면 이동: 가계부 > 상세 drawer
 * to: itemId
 * toModel: LEDGER
 * object: {
 *   fieldId: string,
 *   itemId: string,
 *   itemType: 'SALE' | 'COLLECTION' | 'EXPENSE',
 *   changeType: 'CREATED' | 'UPDATED' | 'DELETED' | 'RESTORED',
 *   date, title, fieldName
 * }
 */
export const LEDGER_ITEM_DETAIL = 'LEDGER_ITEM_DETAIL';
/**
 * 설명: 영업노트 추가시 (루트계정 + 현장담당자)에게 알림 전송
 * 트리거: 매출처 > 영업노트 > 추가
 * 수신자: 매출처 + 담당직원
 * 화면 이동: 영업노트 > 상세
 * 특이사항: -
 * to: _id (영업노트 _id)
 * toModel: Field
 * object: {
 *   fieldId: string, // 현장 _id
 *   salesNoteItemId: string, // 영업노트 _id
 * }
 */
export const SALES_NOTE_ITEM_ADDED = 'SALES_NOTE_ITEM_ADDED';
/**
 * 설명: 매출처 직원이 현장예산을 요청하면 루트계정에게 알립니다.
 * 트리거: 매출처 > 현장예산 요청
 * 수신자: 매출처(루트계정)
 * 화면 이동: 현장관리 > 예산
 * 특이사항: -
 * to: _id (현장 _id)
 * toModel: User.partner.materialBuyer.fields.budgetRequests
 * object._budgetRequestId
 */
export const MATERIAL_BUDGET_REQUEST = 'MATERIAL_BUDGET_REQUEST';
/**
 * 설명: 고객이 회원가입시 초대한 매출처에게 알립니다.
 * 트리거: 수주지원 > 고객 가입 이메일 인증 > 회원가입 완료
 * 수신자: 매출처
 * 화면 이동: 현장관리
 * 특이사항: -
 * to: _id (현장 _id)
 * toModel: User.partner.materialBuyer.fields
 */
export const O_S_CUSTOMER_JOIN = 'O_S_CUSTOMER_JOIN';
/**
 * 설명: 회의록 작성시 매출처에게 알립니다.
 * 트리거: 내부 CRM, 앱/매출처 CRM > 회의록 작성
 * 수신자: 루트 계정 + 현장직원 + 고객 - 작성자
 * 화면 이동: 현장관리 > 회의록 > 상세
 * 특이사항: -
 * to: _id (현장 _id)
 * toModel: User.partner.materialBuyer.fields.minutesOfMeetings
 * object._fieldId: 현장 _id
 * object._momId: 회의록 _id
 */
export const FIELD_MOM = 'FIELD_MOM';
/**
 * 설명: 현장보고 작성시 매출처에게 알립니다.
 * 트리거: 내부 CRM, 앱/매출처 CRM > 현장 보고 작성
 * 수신자: 현장에 소속된 사람들(작성자 제외) + 고객
 * 화면 이동: 현장관리 > 현장 보고 > 상세
 * 특이사항: -
 * to: _id (현장 _id)
 * toModel: User.partner.materialBuyer.fields.workLogs
 * object._fieldId: 현장 _id
 * object._workLogId: 현장 보고 _id
 */
export const FIELD_WORK_LOG = 'FIELD_WORK_LOG';
/**
 * 설명: 현장보고 댓글 작성시 매출처에게 알립니다.
 * 트리거: 내부 CRM, 앱/매출처 CRM > 현장 보고 댓글 작성
 * 수신자: 현장 보고 작성자 + 댓글단 사용자들 + 고객
 * 화면 이동: 현장관리 > 현장 보고 > 상세
 * 특이사항: -
 * to: _id (현장 _id)
 * toModel: User.partner.materialBuyer.fields.workLogs
 * object._fieldId: 현장 _id
 * object._workLogId: 현장 보고 _id
 */
export const FIELD_WORK_LOG_COMMENT = 'FIELD_WORK_LOG_COMMENT';
/**
 * 설명: 각 매출처별 현장예산 알림일에 매출처에게 알립니다.
 * 트리거: [Scheduler] 현장예산 발주알림
 * 수신자: 매출처
 * 화면 이동: 현장관리 > 자재투입
 * 특이사항: 해당 현장의 담당직원에게도 알립니다
 * to: null
 * toModel: 알림 화면
 */
export const MATERIAL_BUDGET_PLAN = 'MATERIAL_BUDGET_PLAN';
/**
 * 설명: 현장일정 당일에 매출처에게 알립니다.
 * 트리거: [Scheduler] 현장일정 알림
 * 수신자: 매출처
 * 화면 이동: 현장관리
 * 특이사항: 해당 현장의 담당직원에게도 알립니다
 * to: null
 * toModel: 알림 화면
 */
export const MATERIAL_FIELD_SCHEDULE = 'MATERIAL_FIELD_SCHEDULE';
/**
 * 설명: 현장대화방에 메세지 작성시 대화방에 있는 사용자에게 알립니다.
 * 트리거: 앱/매출처 CRM, 고객 앱 > 현장 대화방 > 메세지 전송
 * 수신자: 현장에 소속된 사람들(작성자 제외) + 고객
 * 화면 이동: 현장관리 > 대화방
 * 특이사항: -
 * to: _id (현장 _id)
 * toModel: User.partner.materialBuyer.fields
 */
export const FIELD_COMMENT = 'FIELD_COMMENT';
/**
 * 설명: 현장에 직원이 등록시 알립니다.
 * 트리거: 현장 > 담당직원 등록
 * 수신자: 담당직원(새롭게 추가된 인원만)
 * 화면 이동: 현장
 * 특이사항: -
 * to: _id (현장 _id)
 * toModel: User.partner.materialBuyer.fields
 */
export const FIELD_JOINED_STAFF = 'FIELD_JOINED_STAFF';
/**
 * 설명: 관리자가 간편 디자인 신청에 대한 문의를 답변하면 매출처에게 알립니다.
 * 트리거: 내부 CRM > 1:1 문의 답변 > 답변완료 처리(최초 한번만 전송)
 * 수신자: 매출처
 * 조건:
 *  object.type === REQUEST_DESIGN:
 *    화면 = 매출처 > 디자인 신청 > 상세
 * toModel: Inquiry
 */
export const INQUIRY_REQUEST_DESIGN = 'INQUIRY_REQUEST_DESIGN';
/**
 * 설명: 관리자가 우리 현장 요청에 대한 문의를 답변하면 매출처에게 알립니다.
 * 트리거: 내부 CRM > 1:1 문의 답변 > 답변완료 처리(최초 한번만 전송)
 * 수신자: 매출처
 * 조건:
 *  object.type === SETTING_MATERIAL:
 *    화면 = 매출처 > 현장상세
 *    to = field id
 * toModel: Inquiry
 */
export const INQUIRY_SETTING_MATERIAL = 'INQUIRY_SETTING_MATERIAL';
/**
 * 설명: 관리자가 우리 회사 자재 요청에 대한 문의를 답변하면 매출처에게 알립니다.
 * 트리거: 내부 CRM > 1:1 문의 답변 > 답변완료 처리(최초 한번만 전송)
 * 수신자: 매출처
 * 조건:
 *  object.type === INQUIRY_SETTING_FAVORITE:
 *    화면 = 매출처 > 자재찾기 > 즐겨찾기
 * toModel: Inquiry
 */
export const INQUIRY_SETTING_FAVORITE = 'INQUIRY_SETTING_FAVORITE';
/**
 * 설명: 고객이 매출처의 초대수락
 * 트리거: 고객 > 홈 > 초대 수락
 * 수신자: 매출처 + 담당직원
 * 화면 이동: 고객 대화방
 * 특이사항: -
 * to: _id (현장 _id)
 * toModel: Field
 */
export const FIELD_INVITATION_ACCEPT = 'FIELD_INVITATION_ACCEPT';
